export const formPatterns = [
  {
    key: 'email',
    pattern: '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[.a-zA-Z0-9]+$',
  },
  {
    key: 'password',
    pattern: '^(.*(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])).*$',
  },
  {
    key: 'path',
    pattern: '^[a-z0-9](-?_?[a-z0-9])*$',
  },
  {
    key: 'galleryPath',
    pattern: '^[a-zA-Z0-9-_]+$',
  },
  {
    key: 'website',
    pattern: '^(https://|http://|)[a-zA-Z0-9_-]{1,}[.][.a-zA-Z0-9_-]{1,}.*$',
  },
  {
    key: 'externalUrl',
    pattern: '^(https://|http://|)[a-zA-Z0-9_-]{1,}[.][.a-zA-Z0-9_-]{1,}.*$',
  },
  {
    key: 'externalUrlOrMailto',
    pattern: '^(https://|http://|mailto:|)[a-zA-Z0-9@_-]{1,}[.][.a-zA-Z0-9_-]{1,}.*$',
  },
  {
    key: 'phone',
    pattern: '^[0-9+-\\s]{5,18}$',
  },
  {
    key: 'approval-limit',
    pattern: '^[0-9]*$',
  },
  {
    key: 'custom-domain',
    pattern: '^(https://|http://|)[a-z0-9-._]*.{1,}[a-z]{1,}$',
  },
];
